// split string into array
// map over array
// replace _ with space
// lowercase the whole string
// capitalize first letter of each word

export const labelize = (
  value: string | string[],
  transformToLowerCase: boolean | undefined = false
) => {
  return (Array.isArray(value) ? value : value.split(",")).map((item) => {
    let str = item.trim();
    if (transformToLowerCase) {
      str = str.toLowerCase();
    }
    return str
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char: string) => char.toUpperCase());
  });
};
